import { render, staticRenderFns } from "./UberComii.vue?vue&type=template&id=476be4c3&scoped=true&"
import script from "./UberComii.vue?vue&type=script&lang=js&"
export * from "./UberComii.vue?vue&type=script&lang=js&"
import style0 from "./UberComii.vue?vue&type=style&index=0&id=476be4c3&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476be4c3",
  null
  
)

export default component.exports